"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { Card, Form, Input, Button, Typography, Alert, Space } from "antd";
import { useAuth } from "@/features/auth";
import { PRODUCT_NAME } from "@/shared/config/labels";

const { Title, Paragraph } = Typography;

interface LoginFormValues {
  email: string;
  password: string;
}

export default function AdminLoginPage() {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const router = useRouter();

  const handleSubmit = async (values: LoginFormValues) => {
    setLoading(true);
    setError(null);
    try {
      const user = await login(values.email, values.password);
      router.push(user.role === "superadmin" ? "/admin/dashboard" : "/company/dashboard");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Ошибка входа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        padding: 16,
      }}
    >
      <div style={{ width: "100%", maxWidth: 400 }}>
        <Space direction="vertical" align="center" style={{ width: "100%", marginBottom: 32 }}>
          <Link href="/">
            <Title level={2} style={{ margin: 0 }}>{PRODUCT_NAME}</Title>
          </Link>
          <Paragraph type="secondary">Вход в систему</Paragraph>
          <Paragraph type="secondary" style={{ fontSize: 13, textAlign: "center", marginBottom: 0 }}>
            Аккаунты компаний выдаёт администратор платформы
          </Paragraph>
        </Space>
        <Card>
          <Form layout="vertical" onFinish={(values) => void handleSubmit(values)}>
            <Form.Item
              name="email"
              label="Эл. почта"
              rules={[{ required: true, message: "Введите адрес эл. почты" }]}
            >
              <Input type="email" autoComplete="email" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Пароль"
              rules={[{ required: true, message: "Введите пароль" }]}
            >
              <Input.Password autoComplete="current-password" />
            </Form.Item>
            {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} />}
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Войти
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
}
